import { canViewGrowthCalculator } from '@utils/investment-entity';
import { investmentEntity } from '@store/modules/investment-entity';
import { RouteConfig } from 'vue-router';

const growthCalculatorRoutes: Array<RouteConfig> = [
	{
		path: '/growth-calculator',
		name: 'growth-calculator',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		beforeEnter: async (to, from, next) => {
			if (canViewGrowthCalculator(investmentEntity)) {
				await next();
			} else {
				await next({ name: 'account-overview', replace: true });
			}
		},
		component: () =>
			import(/* webpackChunkName: "growth-calculator" */ '@views/growth-calculator/growth-calculator.vue')
	}
];

export default growthCalculatorRoutes;
